'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Info = require('./Info');

var _Info2 = _interopRequireDefault(_Info);

var _Methods = require('./Methods');

var _Methods2 = _interopRequireDefault(_Methods);

var _Method = require('./Method');

var _Method2 = _interopRequireDefault(_Method);

var _MethodSummary = require('./MethodSummary');

var _MethodSummary2 = _interopRequireDefault(_MethodSummary);

var _MethodDescription = require('./MethodDescription');

var _MethodDescription2 = _interopRequireDefault(_MethodDescription);

var _MethodTags = require('./MethodTags');

var _MethodTags2 = _interopRequireDefault(_MethodTags);

var _MethodURL = require('./MethodURL');

var _MethodURL2 = _interopRequireDefault(_MethodURL);

var _MethodResponses = require('./MethodResponses');

var _MethodResponses2 = _interopRequireDefault(_MethodResponses);

var _MethodParameters = require('./MethodParameters');

var _MethodParameters2 = _interopRequireDefault(_MethodParameters);

var _MethodExamples = require('./MethodExamples');

var _MethodExamples2 = _interopRequireDefault(_MethodExamples);

var _MethodTest = require('./MethodTest');

var _MethodTest2 = _interopRequireDefault(_MethodTest);

var _Definitions = require('./Definitions');

var _Definitions2 = _interopRequireDefault(_Definitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * TODO:
 * 1. SwaggerUI.Schema section
 * 2. Expand/link/reference schema from parameters
 * 3. Responses can have their own response type
 * 4. Default onExpand view
 */
var SwaggerUI = function (_React$Component) {
	_inherits(SwaggerUI, _React$Component);

	function SwaggerUI(props) {
		_classCallCheck(this, SwaggerUI);

		var _this = _possibleConstructorReturn(this, (SwaggerUI.__proto__ || Object.getPrototypeOf(SwaggerUI)).call(this, props));

		_this.setDialog = _this.setDialog.bind(_this);
		_this.state = {
			dialog: null
		};
		return _this;
	}

	/**
  * Allow children to set a dialog.
  */


	_createClass(SwaggerUI, [{
		key: 'setDialog',
		value: function setDialog(dialog) {
			this.setState({
				dialog: dialog
			});
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return { setDialog: this.setDialog };
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'swagger-ui' },
				this.state.dialog,
				this.props.children
			);
		}
	}]);

	return SwaggerUI;
}(_react2.default.Component);

SwaggerUI.childContextTypes = {
	/**
  * Set a modal dialog to be displayed in the SwaggerUI context.
  */
	setDialog: _propTypes2.default.func
};

SwaggerUI.Info = _Info2.default;
SwaggerUI.Methods = _Methods2.default;
SwaggerUI.Method = _Method2.default;
SwaggerUI.MethodSummary = _MethodSummary2.default;
SwaggerUI.MethodDescription = _MethodDescription2.default;
SwaggerUI.MethodTags = _MethodTags2.default;
SwaggerUI.MethodURL = _MethodURL2.default;
SwaggerUI.MethodResponses = _MethodResponses2.default;
SwaggerUI.MethodParameters = _MethodParameters2.default;
SwaggerUI.MethodExamples = _MethodExamples2.default;
SwaggerUI.MethodTest = _MethodTest2.default;
SwaggerUI.Definitions = _Definitions2.default;

var _default = SwaggerUI;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(SwaggerUI, 'SwaggerUI', 'src/components/SwaggerUI/SwaggerUI.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/SwaggerUI.jsx');
}();

;